var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.95643 6.37419L3.68041 9.4104C3.63953 9.86006 3.61892 10.0868 3.65634 10.302C3.68977 10.4943 3.75655 10.6793 3.85397 10.8485C3.96342 11.0385 4.12519 11.2003 4.4469 11.522L8.75981 15.8349C9.41568 16.4907 9.74379 16.8189 10.1231 16.9421C10.4579 17.0509 10.819 17.0511 11.1538 16.9424C11.5343 16.8187 11.865 16.4884 12.525 15.8284L15.8249 12.5286C16.4849 11.8685 16.8144 11.5387 16.938 11.1581C17.0468 10.8234 17.0461 10.4626 16.9374 10.1279C16.8137 9.74734 16.4847 9.41754 15.8247 8.75752L11.5224 4.45524C11.1978 4.13061 11.0354 3.96827 10.8445 3.85832C10.6754 3.7609 10.4904 3.69384 10.2981 3.6604C10.081 3.62267 9.85231 3.64341 9.39509 3.68498L6.37025 3.95997C5.58294 4.03154 5.18905 4.06748 4.88099 4.23879C4.60938 4.38983 4.38548 4.61373 4.23444 4.88534C4.06399 5.19186 4.02843 5.58296 3.95758 6.36243L3.95643 6.37419Z",
    stroke: "black",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09366 8.09748C8.4191 7.77204 8.4191 7.2444 8.09366 6.91897C7.76822 6.59353 7.24021 6.59353 6.91477 6.91897C6.58934 7.2444 6.58902 7.77191 6.91446 8.09735C7.2399 8.42279 7.76822 8.42291 8.09366 8.09748Z",
    stroke: "black",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/tagIcon.36be765db0811694b46d225cf2fe92ef.svg";
export { ForwardRef as ReactComponent };